module.exports = __webpack_public_path__ + "img/991dd49.png";